import { useState } from "react";
import { faqs } from "@/mocks/baoliaoData";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-10 md:py-16 bg-background-50">
      <div className="max-w-[860px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <span className="inline-flex items-center gap-1.5 text-primary-600 text-xs font-semibold tracking-wider uppercase">
            <i className="ri-questionnaire-line"></i>
            常见问题
          </span>
          <h2 className="font-heading font-extrabold text-2xl md:text-3xl tracking-tight text-foreground-950 mt-2">
            你可能想问
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`rounded-2xl border transition-colors ${
                  isOpen ? "border-primary-200 bg-background-100/60" : "border-background-200 bg-background-50"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-4 md:px-6 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950">{f.q}</h3>
                  <span
                    className={`shrink-0 w-7 h-7 flex items-center justify-center rounded-full transition-colors ${
                      isOpen ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                    }`}
                  >
                    <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                  </span>
                </button>
                {isOpen && (
                  <div className="px-4 md:px-6 pb-5 animate-rise">
                    <p className="text-sm leading-relaxed text-foreground-600">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}